const AdminOptionSet = (token?: string) => {
    let AdminOption: any;
    if (token) {
        AdminOption = {
            headers: {
                Authorization: `Bearer ${token}`,
                'APIKEY': process.env.REACT_APP_API_ADMIN_KEY,
            }
        };

    }
    else {
        AdminOption = {
            headers: {
                'APIKEY': process.env.REACT_APP_API_ADMIN_KEY,
            }
        };
    }
    return { AdminOption }
}

export default AdminOptionSet;